import { Pump } from "./pump";
import { Address } from "./address";


export class PointOfService {
	id: number;
	name: string;
	address: Address;
	geographicCoordinates: {
		latitude: number;
		longitude: number;
	}
	type: string;
	posDataProvider: string;
	description: string;
	externalRef: string;
	idTechnicalProvider: string;
	supplierId: number;
	distance: number;
	paymentMeans: Array<string>;
	pumps: Array<Pump>;
	status: string;
	detail: any;
	vatReference: string;
	currency: string;
	deleted: string;
}
